import axios from 'axios';
import { setupAuthInterceptor } from '../common';
import { NAMESPACES } from '../configuration';
const BASE_URL = NAMESPACES.management_api.local_expenses_categories;

// Helper function to configure the Axios instance
const api = setupAuthInterceptor(axios.create({
    baseURL: BASE_URL,
    headers: {
      'Content-Type': 'application/json'
    }
  }));

  export const getLocalExpensesCategoryById = async (expenseCategoryId: number) => {
    return await api.get(`/GetLocalExpensesCategoryById/${expenseCategoryId}`, {
    });    
}

  export const getAllLocalExpensesCategoryByLocalId = async (localId: number) => {
    return await api.get(`/GetAllLocalExpensesCategoriesByLocalId/${localId}`, {
    });    
}

export const createLocalExpensesCategory = async (ExpenseCategoryData: any) => {
  return await api.post('/CreateLocalExpensesCategory', ExpenseCategoryData, {
  });
}

 export const updateLocalExpensesCategory = async (ExpenseCategoryId: number, ExpenseCategoryData: any) => {
    return await api.put(`/UpdateLocalExpensesCategory/${ExpenseCategoryId}`, ExpenseCategoryData, {
    });
 }

 export const deleteLocalExpensesCategory = async (ExpenseCategoryId: number) => {
  return await api.delete(`/DeleteLocalExpensesCategory/${ExpenseCategoryId}`, {
  });
 }